import React, {
  ChangeEvent,
  FormEvent,
  KeyboardEvent,
  RefObject,
} from 'react';
import PopupModal from 'components/PopupModal/PopupModal';
import Spinner from 'components/Spinner';
import magGlassIcon from 'assets/images/icons/magnifying-glass.svg';
import modalTypes from 'utils/modalTypesEnum';
import { VehicleFormModel } from 'types/common/vehicles';
import styles from './SearchCard.module.scss';

interface ModalFormProps {
  loading: boolean;
  error: string | null;
  inputValues: VehicleFormModel;
  inputChangeHandler: (_event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (_event: FormEvent<HTMLFormElement>) => void;
  onSearch: () => void;
  onClose: () => void;
  validateNumericEntry: (_event: KeyboardEvent<HTMLInputElement>) => void;
  inputRef: RefObject<HTMLInputElement>;
}

const ModalForm: React.FC<ModalFormProps> = ({
  loading,
  error,
  inputValues,
  inputChangeHandler,
  onSubmit,
  onSearch,
  onClose,
  validateNumericEntry,
  inputRef,
}) => (
  <PopupModal
    resultTitle="Add a vehicle"
    action={onClose}
    modalType={modalTypes.formModal}
    innerCloseButton
    roundedEdges
    form={(
      <form
        noValidate
        name="vehicleSaveEditForm"
        onSubmit={onSubmit}
        className="rac-form"
      >
        {error && !loading && (
          <div className={styles.errorMsg}>{error}</div>
        )}
        <fieldset className={styles.fieldset}>

          <div className={styles.inputWrapper}>
            <input
              className={styles.input}
              onChange={inputChangeHandler}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  onSearch();
                }
              }}
              type="text"
              name="Registration"
              value={inputValues.Registration}
              placeholder="Vehicle registration"
              maxLength={8}
              required
              ref={inputRef}
            />
            <button
              type="button"
              className={styles.searchIcon}
              aria-label="Search vehicle registration"
              onClick={onSearch}
            >
              {loading
                ? <Spinner buttonSpinner />
                : <img src={magGlassIcon} alt="Search" />}
            </button>
          </div>

          <div className={styles.inputWrapper}>
            <input
              className={styles.input}
              onKeyPress={validateNumericEntry}
              onChange={inputChangeHandler}
              type="text"
              name="YearOfManufacture"
              value={inputValues.YearOfManufacture}
              placeholder="Vehicle year"
              maxLength={4}
              required
            />
          </div>

          <div className={styles.inputWrapper}>
            <input
              className={styles.input}
              onChange={inputChangeHandler}
              type="text"
              name="Make"
              value={inputValues.Make}
              placeholder="Vehicle make"
              required
              maxLength={50}
            />
          </div>

          <div className={styles.inputWrapperLast}>
            <input
              className={styles.input}
              onChange={inputChangeHandler}
              type="text"
              name="Model"
              value={inputValues.Model}
              placeholder="Vehicle model"
              required
              maxLength={50}
            />
          </div>
        </fieldset>

        <div>
          <button
            type="submit"
            className={styles.addVehicleButton}
            disabled={loading}
          >
            {loading ? 'Loading' : 'Add vehicle'}
          </button>
        </div>

        <div className={styles.note}>
          This free upgrade can only be applied to <b>one</b> nominated vehicle.
        </div>
      </form>
    )}
  />
);

export default ModalForm;
